import React, {Fragment} from 'react'
import styles from './UIGameHelpCostsInformation.module.scss'
import {ModeSettingEnum} from '@colonist/types'
import {getCostInformation, getPieceIconPath} from './UIGameCostsInformation'
import {T} from '@colonist/ui'
import {UIGameCard} from '../../../../common/UIGameCard'
import {PlayerColor} from '@colonist/game-states'

export interface UIGameHelpCostsInformationProps {
    gameMode: ModeSettingEnum
    playerColor: PlayerColor
}

export const UIGameHelpCostsInformation = ({gameMode, playerColor}: UIGameHelpCostsInformationProps) => {
    const costInformation = getCostInformation(gameMode)
    return (
        <div className={styles.uiGameInfoContainer}>
            <div className={styles.description}>
                <T id={{key: 'strings:game.buildCosts.description'}}/>
            </div>
            <div className={styles.itemRow}>
                {costInformation.map((item) => (
                    <Fragment key={item.piece}>
                        <div className={styles.itemTitle}>
                            <img
                                className={styles.icon}
                                src={getPieceIconPath(item.piece, playerColor)}
                            />
                            <div className={styles.title}><T id={item.title}/></div>
                        </div>
                        <div className={styles.costContainer}>
                            {item.cost.map((card, index) => (
                                <UIGameCard
                                    cardEnum={card}
                                    size='xxxs'
                                    key={`${card}-${index}`}
                                />
                            ))}
                        </div>
                    </Fragment>
                ))}
            </div>

        </div>
    )
}
